import React from 'react'
import EventsDetails from '../EventsDetails'

function DesignThinking() {
  return (
    <div>
        <EventsDetails
        title='Design Thinking'
        />
    </div>
  )
}

export default DesignThinking